var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.2 27v-21c0-1.8-1.4-3.2-3.2-3.2h-1.6c-1.8 0-3.4 1.4-3.4 3.2v2.8l4 4-4 4v9.4",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 47.2c-5 1-10-2-11.6-7-1.6-5.4 1.4-11 6.8-12.6 5.4-1.6 11 1.4 12.6 6.8",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 41.2c0 1.2-1 2-2 2-1.2 0-2-1-2-2s1-2 2-2 2 1 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6 47.8c0 6.8-5.4 12.2-12.2 12.2-6.8 0-12.2-5.4-12.2-12.2 0-6.8 5.4-12.2 12.2-12.2 6.8 0 12.2 5.6 12.2 12.2z",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6 47.8c0 6.8-5.4 12.2-12.2 12.2-6.8 0-12.2-5.4-12.2-12.2 0-6.8 5.4-12.2 12.2-12.2 6.8 0 12.2 5.6 12.2 12.2z",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.8 56.4l17.2-17.2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyBlocked);
export default __webpack_public_path__ + "static/media/key_blocked.011eb337127c4f1ca79aeacf4d9212a2.svg";
export { ForwardRef as ReactComponent };